import React from 'react';
import './App.css';
import TodoItem from './todoItem'
import './style.css'
import todoData from './todoData'

class App extends React.Component {
  constructor(){
    super()
    this.state = {
      todos: todoData
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(id){
    this.setState(prevState => {
      const updatesTodos = prevState.todos.map(todo => {
        if(todo.id===id){
          return {
            ...todo,
            completed: !todo.completed
          }
        }
        return todo
      }) 
      return{
        todos: updatesTodos
      }
    })
  }

  render(){
    const todo = this.state.todos.map(item => <TodoItem key={item.id} item={item} handleChange={this.handleChange}/>)

    return(
      <div className = "todo-list">
        {todo}
      </div>
    )
  }
}

export default App;
